enum SearchCountries {
  Australia = 'au',
  UnitedStates = 'us',
  UnitedKingdom = 'gb',
  Indonesia = 'id',
}

export default SearchCountries;
